import React from 'react';
import { OutboundOrderItem } from '../../../../api/warehouse/generated/src';
// import { OrderItem } from '../../types';

interface BatchQtyEditModalProps {
  item: OutboundOrderItem;
  batchIndex: number;
  batchQtyEditInput: string;
  onQtyChange: (value: string) => void;
  onConfirm: () => void;
  onClose: () => void;
}

export const BatchQtyEditModal: React.FC<BatchQtyEditModalProps> = ({
  item,
  batchIndex,
  batchQtyEditInput,
  onQtyChange,
  onConfirm,
  onClose,
}) => {
  const batch = item.selectedBatches?.[batchIndex];
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <h3 className="text-lg md:text-xl font-bold mb-2">Chargen-Menge anpassen</h3>
        <p className="text-gray-700 mb-2 text-sm md:text-base">{item.description}</p>
        <p className="text-sm text-blue-800 font-semibold mb-4">
          Charge: {batch?.batch.batchNumber}
        </p>
        
        <div className="mb-4">
          <label className="block text-sm font-semibold mb-2">
            Menge dieser Charge
          </label>
          <input
            type="number"
            value={batchQtyEditInput}
            onChange={(e) => onQtyChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && batchQtyEditInput) {
                onConfirm();
              }
            }}
            placeholder="Menge eingeben"
            className="w-full p-3 border-2 border-blue-500 rounded-lg text-lg"
            autoFocus
            min="0"
          />
        </div>
        
        <div className="flex gap-2">
          <button
            onClick={onClose}
            className="flex-1 bg-gray-300 text-gray-800 py-2 px-4 rounded-lg font-semibold hover:bg-gray-400 transition"
          >
            Abbrechen
          </button>
          
          <button
            onClick={onConfirm}
            className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg font-semibold hover:bg-blue-700 transition"
          >
            ✓ Bestätigen
          </button>
        </div>
      </div>
    </div>
  );
};